import { deburr } from 'lodash';

/**
 * Normalizes a string by removing diacritics and converting special non EBCDIC compatible characters
 *
 * @param value - The input string to normalize.
 * @returns The normalized string.
 */
export const normalizeValue = (value: string) => {
  // Unicode replacement mappings
  const replacements = {
    '\u2018': "'",
    '\u2019': "'",
    '\u201B': "'",
    '\u201C': '"',
    '\u201D': '"',
    '\u2013': '-',
    '\u2014': '-',
    '\u2026': '...',
    '\u00A0': ' ',
  };

  return deburr(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(
      /[\u2018\u2019\u201B\u201C\u201D\u2013\u2014\u2026\u00A0]/g,
      (x) => replacements[x]
    );
};
